export class Helpers {

    static options = {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        timeZone: 'UTC',
    };
    static option_day = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
    };
    static option_with_time = {
        month: "long",
        day:"numeric",
        hour:"numeric",
        //hourCycle: 'h23',
        minute: "2-digit",
        timeZone: 'UTC',
    }
    static names = {
        edit: 'Edit',
        expiration_date: {
            default: 'Add +',
            mobile: 'Expiration date +'
        },
        down_payment: {
            default: 'Add +',
            mobile: 'Down payment +'
        },
        start_date_time: {
            default: 'Add +',
            mobile: 'Start date/time +'
        },
        due_days_and_late_fees_percent: {
            default: 'Add +',
            mobile: 'Due date and fees +'
        },
        completion_date: {
            default: 'Add +',
            mobile: 'Completion date +'
        }
    };

    static getSubModalForm = (formId, data={}) => {
        let formHTML;
        $.ajax({
            method: "GET",
            url: `/jobs-flow/form`,
            data: $.param({form_id: formId, type: 'sub_form', 'form-request': true, data}),
            async: false,
            success: (form) => {
                formHTML = form;
            }
        });
        return formHTML;
    }

    //the next functions are intended for modal forms "quote" and "invoice"

    static checkMobile(){
        const match = window.matchMedia('(max-width:576px)')
        return match.matches
    }

    static openSubInput(e) {
        const target = $(e.target).parents('.form-action');
        const formId = target.attr('id');
        let nameInputs = target.data('input-names').split(' ').map(el=>el.replace(/\s+/,''))
        let data = {}
        for(let name of nameInputs){
            data[name] = $(`[name="${name}"]`).val();
        }
        const subModal = this.getSubModalForm(formId, data);
        $('#modal-form-container').html(subModal);
        $(`#${formId}-modal`).modal('show');
    }

    static checkDueDaysAndFees() {
        const dueDaysAndFeesContainer = $('.form-action#due_days_and_fees');
        const days = dueDaysAndFeesContainer.find('[name=due_days]').val();
        const percents = dueDaysAndFeesContainer.find('[name=late_fee_percent]').val();
        if (days != '') {
            let message = `${days} days`;
            if (percents != '') {
                message += ` & ${percents}% late fees`;
            }
            dueDaysAndFeesContainer.find('.form-action-result').text(message);
            dueDaysAndFeesContainer.find('.form-action-title').text(Helpers.checkMobile() ? message : Helpers.names.edit);
            if($('.form-action#due_days_and_fees .action-buttons').children('#delete').length === 0){
                $('.form-action#due_days_and_fees .form-action-title').after('<button type="button" class="btn button-delete" id="delete" data-dismiss="modal" aria-label="Close">Delete</button>');
            }
        } else {
            dueDaysAndFeesContainer.find('.form-action-result').text('');
            const names = Helpers.names.due_days_and_late_fees_percent
            dueDaysAndFeesContainer.find('.form-action-title').text(Helpers.checkMobile() ? names.mobile : names.default);
        }
    }

    static checkDates(inputName, options=Helpers.options) {
        const dateContainer = $(`.form-action#${inputName}`);
        let date = dateContainer.find(`[name=${inputName}]`).val();

        if (date) {
            //mad date formatting to show needed info
            date = date.includes('-') ? date.split('-').join(',') : date;
            const simpleDateRegex = /[a-zA-Z]+[\s]+[\d]{1,2}/;
            date = simpleDateRegex.test(date) ?  (date + ', ' + new Date().getFullYear()) : date;
            //
            //console.log(date);
            const timestamp = Date.parse(date) + (new Date().getTimezoneOffset()*-1*60000);
            const formatedDate = new Date(timestamp);
            //console.log(date, formatedDate, formatedDate.toLocaleString("en-US", options));
            dateContainer.find('.form-action-title').text(Helpers.checkMobile() ? formatedDate.toLocaleString("en-US", options) : Helpers.names.edit);
            dateContainer.find('.form-action-result').text(formatedDate.toLocaleString("en-US", options));
            if(inputName === 'start_date_time' && $('.form-action#start_date_time .action-buttons').children('#delete').length === 0) {
                $('.form-action#start_date_time .form-action-title').after('<button type="button" class="btn button-delete" id="delete" data-dismiss="modal" aria-label="Close">Delete</button>');
            } else if(inputName === 'expiration_date' && $('.form-action#expiration_date .action-buttons').children('#delete').length === 0) {
                $('.form-action#expiration_date .form-action-title').after('<button type="button" class="btn button-delete" id="delete" data-dismiss="modal" aria-label="Close">Delete</button>');
            }else if(inputName === 'completion_date' && $('.form-action#completion_date .action-buttons').children('#delete').length === 0){
                $('.form-action#completion_date .form-action-title').after('<button type="button" class="btn button-delete" id="delete" data-dismiss="modal" aria-label="Close">Delete</button>');
            }
        } else {
            const names = Helpers.names[inputName]
            dateContainer.find('.form-action-title').text(Helpers.checkMobile() ? names.mobile : names.default);
        }
    }

    static checkPayment() {
        const paymentContainer = $('.form-action#down_payment');
        const paymentValue = paymentContainer.find('input').val();
        if (paymentValue != '') {
            paymentContainer.find('.form-action-result').text(`$${parseFloat(paymentValue).toFixed(2)}`);
            paymentContainer.find('.form-action-title').text(Helpers.checkMobile() ? `$${parseFloat(paymentValue).toFixed(2)}` : Helpers.names.edit);
            $('.form-action#down_payment .form-action-title').after('<button type="button" class="btn button-delete" id="delete" data-dismiss="modal" aria-label="Close">Delete</button>');
        } else {
            paymentContainer.find('.form-action-result').text('');
            const names = Helpers.names.down_payment
            paymentContainer.find('.form-action-title').text(Helpers.checkMobile() ? names.mobile : names.default);
        }
    }

    static setDueDaysAndFees() {

        const days = $('form#due_days_late_fee_percent [name=days]').val();
        const fees = $('form#due_days_late_fee_percent [name=late_fee_percent]').val();

        $('.form-action#due_days_and_fees [name=due_days]').val(days);
        $('.form-action#due_days_and_fees [name=late_fee_percent]').val(fees);

        $('.modal-form').modal('hide');
        Helpers.checkDueDaysAndFees();
    }

    static setStartDateTime() {

        if ($('form#start_date_time [name=date]').data('DateTimePicker')) {
            const date = $('form#start_date_time [name=date]').data('DateTimePicker').date().format('Y-M-D');
            const time = '';
            $('.form-action#start_date_time [name=start_date_time]').val(`${date}`);
        } else {
            const date = $('form#start_date_time [name=date]').val();
            const time = $('form#start_date_time [name=time]').val() ?? '';
            $('.form-action#start_date_time [name=start_date_time]').val(`${date} ${time}`);
        }

        $('.modal-form').modal('hide');
        Helpers.checkDates('start_date_time', Helpers.option_with_time);
    }

    static setCompleteionDate(old = true) {

        if (old) {
            const date = $('form#completion_date [name=date]').data('DateTimePicker').date().format('Y-M-D');
            const time = '';
            $('.form-action#completion_date [name=completion_date]').val(`${date}`);

            $('.modal-form').modal('hide');
            Helpers.checkDates('completion_date', Helpers.option_day);
        }else{
            const date = $('#create-invoice-container #invoice_date').data('DateTimePicker').date().format('Y-M-D');
            console.log(date);

            $('#create-invoice-container [name=completion_date]').val(`${date}`);

            Helpers.checkDates('completion_date', Helpers.option_day);
        }
    }
    static setDownPayment() {
        const value = $('[name=amount]').val();
        $('[name=down_payment]').val(value.slice(1));
        $('.modal-form').modal('hide');
        Helpers.checkPayment();
    }
    static setExpirationDate() {
        const date = $('form#expiration_date [name=date]').val();
        $('.form-action#expiration_date [name=expiration_date]').val(`${date}`);

        $('.modal-form').modal('hide');
        Helpers.checkDates('expiration_date', Helpers.option_day);
    }

    static deleteAdditionalAttribute(setterId) {
        const attrId = setterId.replace('set_', '');
        const attributes = attrId.split('_and_');

        for (let attribute of attributes) {
            $(`.sub_input[name=${attribute}]`).val(null);
            $(`.sub_input[name=${attribute}]`).parents('.form-action').find('.form-action-result').text('');
        }
        Helpers.checkAdditionalAttributes();
    }

    static checkAdditionalAttributes() {
        Helpers.checkDates('start_date_time', Helpers.option_with_time);
        Helpers.checkDates('expiration_date', Helpers.option_day);
        Helpers.checkDates('completion_date', Helpers.option_day);
        Helpers.checkPayment();
        Helpers.checkDueDaysAndFees();
    }

    static selectElementContents(el) {

        const range = document.createRange();
        range.selectNodeContents(el);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        document.execCommand('copy');
    }
}
